// The Credible theme uses Bootstrap v4 alpha 4,
// which lacks some tooltip functionality.

// This simple implementation uses Tooltip.js
// (and underlying Popper.js for positioning)

var TooltipJsInitializer = function() {
  // Initialized tooltip instances
  this._tooltips = [];
};

TooltipJsInitializer.prototype.init = function() {
  // Handle body clicks
  this._handleBodyClicks();

  // Initialize tooltips
  this._initTooltips();
};

// Hides all tooltips when click outside of tooltips
TooltipJsInitializer.prototype._handleBodyClicks = function() {
  // Hide all tooltips when there's a click outside a tooltip
  var handle = function(e) {
    if ($(e.target).closest('.tooltip-inner').length === 0) {
      this._hideAll();
    }
  };

  // Register body click listener
  $('body').on('click', handle.bind(this));
};


// Initializes all tooltips
TooltipJsInitializer.prototype._initTooltips = function() {
  var initTooltip = function(index, element) {

    var $element = $(element),
		placement = $element.attr('data-tooltipjs-placement'),
		container = $element.attr('data-tooltipjs-container') || false,
		event     = $element.attr('data-tooltipjs-hover') ? 'hover' : 'click',
		title     = $element.attr('data-tooltipjs-title') ? $element.attr('data-tooltipjs-title') : $element.attr('title');

    // Initialize tooltip
    var tooltip = new Tooltip(element, {
      html: true,
      title: title,
      placement: placement,
      container: container,
      trigger: event,
      delay: { "show": 500, "hide": 1500 },
      template: '<div class="tooltipjs" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
    });

    this._tooltips.push(tooltip);
  };

  // Initialize each
  $('[data-tooltipjs]').each(initTooltip.bind(this));
};

// Hide all tooltips
TooltipJsInitializer.prototype._hideAll = function() {
  this._tooltips.forEach(function(tooltip) {
    tooltip.hide();
  });
};

// Boot
(new TooltipJsInitializer()).init();